import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import ForgetPasswordForm from "../../components/UI/Forms/Wizard Forms/LoginForm/ForgetPasswordForm";
import LoginForm from "../../components/UI/Forms/Wizard Forms/LoginForm/LoginForm";
import { CLIENT_ROUTES } from "../../enums/Enums";
import Icons from "../../resources/icons/Icons";
import classes from "./Login.module.css";
import MessageModal from "../../components/UI/Modals/MessageModal/MessageModal";

const Login = () => {
  const location = useLocation();
  const isUserLoggedInState = useSelector((state) => {
    return state.user.isUserLoggedIn;
  });
  const [showForgetPasswordForm, setShowForgetPasswordForm] = useState(false);
  const [showLoginForm, setShowLoginForm] = useState(true);

  useEffect(() => {
    handleLoginChanged();
  }, [isUserLoggedInState]);

  const handleLoginChanged = () => {
    if (!isUserLoggedInState) {
      return (
        <Navigate to={CLIENT_ROUTES.LOGIN} state={{ from: location }} replace />
      );
    } else {
      return (
        <Navigate
          to={CLIENT_ROUTES.PARKERS}
          state={{ from: location }}
          replace
        />
      );
    }
  };
  const handleForgetPassword = () => {
    setShowLoginForm(false);
    setShowForgetPasswordForm(true);
  };
  const handleRememberedLogin = () => {
    setShowLoginForm(true);
    setShowForgetPasswordForm(false);
  };

  return (
    <div className={classes.loginPage}>
      <Grid classes={{ root: classes.root }} container>
        <Grid item xs={4}>
          <div className={classes.formContainer}>
            <img className={classes.logoImg} src={Icons.LOGIN_LOGO}></img>
            {showLoginForm && (
              <LoginForm
                className={classes.form}
                handleForgetPassword={handleForgetPassword}
              />
            )}
            {showForgetPasswordForm && (
              <ForgetPasswordForm
                className={classes.form}
                handleRememberedLogin={handleRememberedLogin}
              />
            )}
          </div>
        </Grid>
        <Grid item xs={8}>
          <div className={classes.imgContainer}>
            <div>
              {showLoginForm && (
                <img className={classes.image} src={Icons.LOGIN_CAR}></img>
              )}
              {showForgetPasswordForm && (
                <img
                  className={classes.image}
                  src={Icons.RESET_PASSWORD_CAR}
                ></img>
              )}
              <div className={classes.title}>Smarter Parking Solutions</div>
            </div>
          </div>
        </Grid>
      </Grid>
      <MessageModal/>
    </div>
  );
};

export default Login;
